import { Component } from '@angular/core';

@Component({
    selector: 'app-politica-terminos-condiciones',
    templateUrl: './politica-terminos-condiciones.component.html',
    styleUrls: ['./politica-terminos-condiciones.component.scss'],
    standalone: false
})
export class PoliticaTerminosCondicionesComponent {}
